import { useEffect } from 'react'

const setHidden = (hide: boolean) => {
  if (typeof window.Intercom !== 'function') return
  window.Intercom('update', { hide_default_launcher: hide })
}

const useHideIntercom = () => {
  useEffect(() => {
    setHidden(true)

    return () => {
      setHidden(false)
    }
  }, [])
}

export default useHideIntercom
